'use client';

import { useState } from 'react';
import type { Category } from 'shared/types/product';
import { useDebounce } from 'use-debounce';
import { useProduct } from 'frontastic';
import SearchModalControlled from './SearchModalControlled';

type Props = {
  categories: Category[];
  onClose: () => void;
};

const SearchModal: React.FC<Props> = ({ categories, onClose }) => {
  const [query, setQuery] = useState('');

  const [debouncedQuery] = useDebounce(query, 150);

  const { products } = useProduct({ query: debouncedQuery, limit: 6 });

  return <SearchModalControlled categories={categories} items={products} onQueryUpdate={setQuery} onClose={onClose} />;
};

export default SearchModal;
